import React from "react";
import { certifications } from "../data/content";

export default function Credentials() {
  return (
    <section id="credentials" className="section-pad border-t border-rule bg-canvas-raised">
      <div className="wrap">
        <header className="reveal mb-12 max-w-3xl">
          <p className="label">05 / Certifications & credentials</p>
          <h2 className="mt-4 font-display text-[clamp(1.75rem,3vw,2.5rem)] font-semibold tracking-[-0.02em]">
            Current professional credentials
          </h2>
          <p className="mt-4 text-ink-secondary">
            Cloud, AI, and engineering credentials that complement hands-on
            security, infrastructure, and software work.
          </p>
        </header>

        <div className="grid gap-px border border-rule bg-rule md:grid-cols-2">
          {certifications.map((credential) => (
            <article
              key={credential.name}
              className="reveal flex flex-col bg-canvas p-6 md:p-8"
            >
              <p className="label text-accent-strong">{credential.issuer}</p>
              <h3 className="mt-3 font-display text-xl font-semibold tracking-tight">
                {credential.name}
              </h3>
              {credential.period ? (
                <p className="mt-2 font-mono text-[0.75rem] text-ink-muted">
                  {credential.period}
                </p>
              ) : null}
              <p className="mt-4 text-sm text-ink-secondary">{credential.detail}</p>
              {credential.credentialId ? (
                <p className="mt-auto pt-5 font-mono text-[0.6875rem] uppercase tracking-[0.06em] text-ink-muted">
                  Credential ID · {credential.credentialId}
                </p>
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
